module.exports = __webpack_public_path__ + "img/pic7.7a7ca122.jpg";